import RewriteTextDialog from "@/components/Common/RewriteTextDialog/RewriteTextDialog.vue";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "EventDescription",
  components: {
    RewriteTextDialog
  },
  data: () => ({
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
    selectedTab: "",
    mainPeacock: "#00636C",
    rewriteTextDialogOpen: false,
    rewriteTextDialogOriginal: "",
    rewriteTextDialogTargetKey: "content",
    prompts_api_client_url: env.prompts_api_client_url
  }),
  computed: {
    tabs() {
      let tabs = ["Beschreibung"];
      this.editedEvent?.channels?.forEach(c => {
        const found = this.channels.find(v => v.value === c);
        if (found) {
          tabs.push("Beschreibung (" + found.title + ")");
          if (!this.editedEvent.alternative_content[found.value]) {
            this.editedEvent.alternative_content[found.value] = {
              description: "",
              short_description: ""
            };
          }
        }
      });
      tabs.push("Anreise");
      return tabs;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    isPromptUser() {
      if (this.isAdmin) {
        return true;
      }
      return this.$store.state.currentUser?.scopes.includes("role:prompt");
    },
    saveTargetOptions() {
      const options = [];
      if (!this.isOwnedBySubPrincipal) {
        options.push({ value: "content", text: "Standard – Beschreibung" });
      }
      this.editedEvent?.channels?.forEach(c => {
        const found = this.channels?.find(v => v.value === c);
        if (found && !this.isTabDisabled(c)) {
          options.push({ value: c, text: `Kanal – ${found.title}` });
        }
      });
      return options;
    }
  },
  methods: {
    isOwnChannel(channelValue) {
      return this.config.own_channels?.find(
        channel => channel.value === channelValue
      );
    },
    isTabDisabled(channelValue) {
      if (!this.isOwnedBySubPrincipal) {
        return false;
      }
      return !this.isOwnChannel(channelValue);
    },
    copyDescriptionToClipboard(html) {
      const blob = new Blob([html], { type: "text/html" });
      // eslint-disable-next-line no-undef
      const data = [new ClipboardItem({ "text/html": blob })];

      navigator.clipboard.write(data);
    },
    openRewriteDialog(text, targetKey = "content") {
      if (this.isTabDisabled(targetKey)) {
        return;
      }
      this.rewriteTextDialogOriginal = text || "";
      this.rewriteTextDialogTargetKey = targetKey;
      this.rewriteTextDialogOpen = true;
    },
    onRewriteTextDialogClose() {
      this.rewriteTextDialogOpen = false;
      this.rewriteTextDialogOriginal = "";
      this.rewriteTextDialogTargetKey = "content";
    },
    onRewriteTextGenerated() {
      // Dialog stays open, user can regenerate or apply
    },
    onRewriteTextApplied(payload) {
      const { text, targetKey } = payload;
      if (!text) return;

      if (targetKey === "content") {
        this.editedEvent.description = text;
      } else {
        if (!this.editedEvent.alternative_content[targetKey]) {
          this.$set(this.editedEvent.alternative_content, targetKey, {
            description: "",
            short_description: ""
          });
        }
        this.editedEvent.alternative_content[targetKey].description = text;
      }

      this.onRewriteTextDialogClose();
    },
    onRewriteTextError(errorPayload) {
      const { text } = errorPayload;
      this.$store.commit("SET_SNACKBAR_COLOR", "#c55c52");
      this.$store.commit(
        "SET_SNACKBAR_TEXT",
        text || "Ein Fehler ist aufgetreten."
      );
      this.$store.dispatch("setSnackbar", true);
    }
  },
  props: [
    "editedEvent",
    "step",
    "position",
    "channels",
    "config",
    "isOwnedBySubPrincipal"
  ]
};
